__turbopack_context__.v({
  "activities": "Activities-module__A0e8CW__activities",
  "activitiesHeader": "Activities-module__A0e8CW__activitiesHeader",
  "activitiesPagination": "Activities-module__A0e8CW__activitiesPagination",
});
